import { render, staticRenderFns } from "./ModalNewsMain.vue?vue&type=template&id=fc15e47e&scoped=true"
import script from "./ModalNewsMain.vue?vue&type=script&lang=js"
export * from "./ModalNewsMain.vue?vue&type=script&lang=js"
import style0 from "./ModalNewsMain.vue?vue&type=style&index=0&id=fc15e47e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc15e47e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBadge,VBtn,VIcon})
